module.exports = __webpack_public_path__ + "assets/img/follow.6a5829c7.png";